import { CircleAlert, LoaderCircle } from "lucide-react";

export function QueryLoading({ label = "Carregando dados…" }: { label?: string }) {
  return (
    <div className="query-state">
      <LoaderCircle className="spin" size={20} />
      <span>{label}</span>
    </div>
  );
}

export function QueryError({ error }: { error: unknown }) {
  return (
    <div className="query-state query-error">
      <CircleAlert size={20} />
      <div>
        <strong>Não foi possível carregar.</strong>
        <span>{error instanceof Error ? error.message : "Erro inesperado."}</span>
      </div>
    </div>
  );
}
